import { call, put, takeLatest } from 'redux-saga/effects';
import { HealthClaim } from '@models/HealthClaim';
import { HealthClaimApi } from '@apis/HealthClaimApi';
import { BenefitLimit } from '@models/BenefitLimit';
import { BenefitLimitApi } from '@apis/BenefitLimitApi';
import { SagaPayload } from '@utils/typescript';
import {
  benefitLimitsFetch,
  BenefitLimitsFetchPayload,
  healthClaimCostItemsFetch,
  HealthClaimCostItemsFetchPayload,
  healthClaimCostItemCreate,
  HealthClaimCostItemCreatePayload,
  healthClaimCostItemCreateSuccess,
  healthClaimCostItemUpdate,
  HealthClaimCostItemUpdatePayload,
  healthClaimCostItemUpdateSuccess,
  healthClaimCostItemDelete,
  HealthClaimCostItemDeletePayload,
  healthClaimCostItemDeleteSuccess,
  healthClaimCostItemsApprove,
  HealthClaimCostItemsApprovePayload,
  healthClaimFetch,
  HealthClaimFetchPayload,
  healthClaimUploadDocuments,
  HealthClaimUploadDocumentsPayload,
  stateUpdate,
  StateUpdatePayload
} from './action';
import { HealthClaimCostItemApi } from '@apis/HealthClaimCostItemApi';
import { HealthClaimCostItem } from '@models/HealthClaimCostItem';

function* handleHealthClaimFetch({ payload }: SagaPayload<HealthClaimFetchPayload>) {
  const state: StateUpdatePayload = { healthClaim: null };
  try {
    state.healthClaim = (yield call(HealthClaimApi.get, payload)) as HealthClaim;
    yield put(stateUpdate(state));
  } catch {
    yield put(stateUpdate(state));
  }
}

function* handleHealthClaimUploadDocuments({ payload }: SagaPayload<HealthClaimUploadDocumentsPayload>) {
  try {
    const state: StateUpdatePayload = { healthClaim: null };
    state.healthClaim = (yield call(HealthClaimApi.uploadDocuments, payload)) as HealthClaim;
    yield put(stateUpdate(state));
  } catch { }
}

function* handleBenefitLimitsFetch({ payload }: SagaPayload<BenefitLimitsFetchPayload>) {
  const state: StateUpdatePayload = { benefitLimits: null };
  try {
    state.benefitLimits = (yield call(BenefitLimitApi.getAll, payload)) as BenefitLimit[];
    yield put(stateUpdate(state));
  } catch {
    yield put(stateUpdate(state));
  }
}

function* handleHealthClaimCostItemsFetch({ payload }: SagaPayload<HealthClaimCostItemsFetchPayload>) {
  const state: StateUpdatePayload = { healthClaimCostItems: null };
  try {
    state.healthClaimCostItems = (yield call(HealthClaimCostItemApi.getAll, payload)) as HealthClaimCostItem[];
    yield put(stateUpdate(state));
  } catch {
    yield put(stateUpdate(state));
  }
}

function* handleHealthClaimCostItemCreate({ payload }: SagaPayload<HealthClaimCostItemCreatePayload>) {
  try {
    const healthClaimCostItem = (yield call(HealthClaimCostItemApi.create, payload)) as HealthClaimCostItem;
    yield put(healthClaimCostItemCreateSuccess({ healthClaimCostItem }))
  } catch { }
}

function* handleHealthClaimCostItemUpdate({ payload }: SagaPayload<HealthClaimCostItemUpdatePayload>) {
  try {
    const healthClaimCostItem = (yield call(HealthClaimCostItemApi.update, payload)) as HealthClaimCostItem;
    yield put(healthClaimCostItemUpdateSuccess({ healthClaimCostItem }));
  } catch { }
}

function* handleHealthClaimCostItemDelete({ payload }: SagaPayload<HealthClaimCostItemDeletePayload>) {
  try {
    const healthClaimCostItem = (yield call(HealthClaimCostItemApi.delete, payload)) as HealthClaimCostItem;
    yield put(healthClaimCostItemDeleteSuccess({ healthClaimCostItem }));
  } catch { }
}

function* handleHealthClaimCostItemsApprove({ payload }: SagaPayload<HealthClaimCostItemsApprovePayload>) {
  try {
    const state: StateUpdatePayload = { healthClaimCostItems: null };
    state.healthClaimCostItems = (yield call(HealthClaimCostItemApi.approveAll, payload)) as HealthClaimCostItem[];
    yield put(stateUpdate(state));
  } catch { }
}

export default function* () {
  yield takeLatest(healthClaimFetch, handleHealthClaimFetch);
  yield takeLatest(healthClaimUploadDocuments, handleHealthClaimUploadDocuments);
  yield takeLatest(benefitLimitsFetch, handleBenefitLimitsFetch);
  yield takeLatest(healthClaimCostItemsFetch, handleHealthClaimCostItemsFetch);
  yield takeLatest(healthClaimCostItemCreate, handleHealthClaimCostItemCreate);
  yield takeLatest(healthClaimCostItemUpdate, handleHealthClaimCostItemUpdate);
  yield takeLatest(healthClaimCostItemDelete, handleHealthClaimCostItemDelete);
  yield takeLatest(healthClaimCostItemsApprove, handleHealthClaimCostItemsApprove);
}
